import { render, staticRenderFns } from "./cadastrar.vue?vue&type=template&id=4193d991&scoped=true"
import script from "./cadastrar.vue?vue&type=script&lang=js"
export * from "./cadastrar.vue?vue&type=script&lang=js"
import style0 from "./cadastrar.vue?vue&type=style&index=0&id=4193d991&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4193d991",
  null
  
)

export default component.exports